import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import healthAdviceService from "./healthAdviceService";
import { toast } from "react-toastify";

export const getHealthAdvices = createAsyncThunk(
  "healthAdvice/get-all",
  async (_, thunkAPI) => {
    try {
      return await healthAdviceService.getHealthAdvices();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAHealthAdvice = createAsyncThunk(
  "healthAdvice/get-one",
  async (id, thunkAPI) => {
    try {
      return await healthAdviceService.getAHealthAdvice(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createHealthAdvice = createAsyncThunk(
  "healthAdvice/create",
  async (adviceData, thunkAPI) => {
    try {
      return await healthAdviceService.createHealthAdvice(adviceData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHealthAdvice = createAsyncThunk(
  "healthAdvice/update",
  async (data, thunkAPI) => {
    try {
      return await healthAdviceService.updateHealthAdvice(data.id, data.adviceData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteHealthAdvice = createAsyncThunk(
  "healthAdvice/delete",
  async (id, thunkAPI) => {
    try {
      return await healthAdviceService.deleteHealthAdvice(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  healthAdvices: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const healthAdviceSlice = createSlice({
  name: "healthAdvice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHealthAdvices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHealthAdvices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.healthAdvices = action.payload;
      })
      .addCase(getHealthAdvices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createHealthAdvice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createHealthAdvice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdAdvice = action.payload;
        toast.success("Medical Protocol Synchronized!");
      })
      .addCase(createHealthAdvice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAHealthAdvice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAHealthAdvice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.singleAdvice = action.payload;
      })
      .addCase(updateHealthAdvice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateHealthAdvice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedAdvice = action.payload;
        toast.success("Medical Protocol Updated!");
      })
      .addCase(deleteHealthAdvice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedAdvice = action.payload;
        state.healthAdvices = state.healthAdvices.filter(item => item._id !== action.meta.arg);
        toast.info("Medical Protocol Terminated.");
      })
      .addCase(resetState, () => initialState);
  },
});

export default healthAdviceSlice.reducer;
